import React from "react";

import { styled } from "@mui/material";

import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";
import { cls } from "../../../../util";

interface BarProps {
  className?: string;
  progress: number;
}

export const Bar = ({ progress, className }: BarProps) => {
  return (
    <Container className={cls("ig-inactive", className)}>
      <Progress className={"ig-active"} progress={progress}>
        &nbsp;
      </Progress>
    </Container>
  );
};

const Container = styled("div")(() => {
  const { device } = useProgressBarContext();
  const { inactiveColor, thickness, cornerRadius } = device.widget.styles.bar;
  return {
    width: "100%",
    background: inactiveColor,
    height: thickness,
    borderRadius: 0.5 * cornerRadius,
  };
});

const Progress = styled("div")(({ progress }: BarProps) => {
  const { device } = useProgressBarContext();
  if (progress < 0) {
    progress = 0;
  } else if (progress > 100) {
    progress = 100;
  }

  const { activeColor, cornerRadius } = device.widget.styles.bar;
  return {
    background: activeColor,
    width: `${progress}%`,
    transition: "width 1s",
    height: `100%`,
    borderRadius: 0.5 * cornerRadius,
  };
});
